<template>
  <LLPage class="ChatSearchPage">
    <template #breadcrumbs>
      <LLBreadCrumbs :crumbs="crumbs" />
    </template>
    <template #content>
      <LLLoader v-if="isFetching"></LLLoader>
      <LLLoaderError v-else-if="error">
        {{ error }}
      </LLLoaderError>
      <div v-else class="ChatSearchPage__content">
        <MemberProfileFlow v-if="chat" :chat="chat" />
        <ForumChatEditorDetailsContent
          :chat="chat"
          is-actions-hidden
          class="ForumChatEditorDetails__content"
        />
        <div class="SearchPage__delimiter"></div>
        <SearchModule :chat="chat"></SearchModule>
      </div>
    </template>
  </LLPage>
</template>

<script>
import LLPage from '@/components/layout/LLPage'
import LLLoader from '@/components/common/LLLoader'
import LLLoaderError from '@/components/common/LLLoaderError'
import LLBreadCrumbs from '@/components/common/ui-components/LLBreadCrumbs'
import { ForumChatModel } from '@/models/forum/forumChat'
import ForumChatEditorDetailsContent from '@/components/pages/forum/chat/editor/main/ForumChatEditorDetailsContent.vue'
import SearchModule from '@/components/pages/search/SearchModule.vue'
import MemberProfileFlow from '@/components/pages/forum/member-profile/MemberProfileFlow.vue'
export default {
  name: 'ChatSearchPage',
  components: {
    SearchModule,
    ForumChatEditorDetailsContent,
    MemberProfileFlow,
    LLBreadCrumbs,
    LLLoaderError,
    LLLoader,
    LLPage
  },
  data() {
    return {
      chat: null,
      isFetching: false,
      error: null,
      redirectedFromDestination: false
    }
  },
  computed: {
    crumbs() {
      return [
        { name: this.$t('main_home_label'), path: '/' },
        {
          name: this.$t('forum.chat_list_page.title', { teamName: this.selectedTeam?.name }),
          path: '/chats'
        },
        ...(this.threadIdParam
          ? [
              {
                name: this.thread?.title || this.$t('forum.breadcrumbs.thread_placeholder'),
                path: `/chats/${this.chatIdParam}/threads/${this.threadIdParam}`
              }
            ]
          : []),
        {
          name: this.$t('forum.chat_search_page.title')
        }
      ]
    },
    chatIdParam() {
      return +this.$route.params.chatId
    }
  },
  created() {
    if (+this.$store.state?.completeRegistration?.chatId === this.chatIdParam) {
      this.redirectedFromDestination = true
    }
    this.$store.commit('completeRegistration/RESET_DESTINATION')
    this.fetch()
  },
  methods: {
    async fetch() {
      this.error = null
      this.isFetching = true
      try {
        const { chat: serverChat } = await this.$api.forum.chats.get({ chatId: this.chatIdParam })
        const chat = ForumChatModel.parseFromApi({ chat: serverChat })
        this.chat = chat
      } catch (e) {
        if (e.response.status === 404) {
          if (this.redirectedFromDestination) {
            this.$router.replace('/chats')
          } else {
            this.$router.replace('/404')
          }
        } else {
          this.error = this.$getErrorMessage(e)
        }
      }
      this.isFetching = false
    }
  }
}
</script>

<style lang="scss" scoped>
.ChatSearchPage {
}
</style>
